import { createPublicClient } from '@polymarket/client';

type PolyClient = ReturnType<typeof createPublicClient>;

let instance: PolyClient | null = null;

export function getPolyClient(): PolyClient {
  if (!instance) instance = createPublicClient();
  return instance;
}
